import { render, staticRenderFns } from "./CotStruttureEditComponent.vue?vue&type=template&id=ad89d6f0"
import script from "./CotStruttureEditComponent.vue?vue&type=script&lang=js"
export * from "./CotStruttureEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports